<template>
  <div class="faqs">
    <b-row>
      <b-col
        col
        lg="11"
        md="8"
        sm="8"
        style="background-color: #fbfbfc"
        class="mx-auto"
      >
        <h3 class="faqs-header">Frequently Asked Questions</h3>

        <hr />
        <br />

        <b-row>
          <b-col class="mx-auto" col lg="6" md="11" sm="11">
            <b-row>
              <span class="faq">What is ePosta?</span>
            </b-row>

            <b-row>
              <span class="faq-answer">
                This is a Posta Uganda online platform that allows anybody to
                access Postal services anytime anywhere.
              </span>
            </b-row>

            <b-row>
              <span class="faq">What Is A Physical Box Address?</span>
            </b-row>

            <b-row>
              <span class="faq-answer">
                A Physical Box Address is a Postal Address where you are given a
                key for your box. This Postal Address is also linked to your
                phone, email and your account online. This allows you to receive
                instant notifications and monitor your box transactions using
                your online account once items/mails come to your box. You can
                request for delivery and or Item pick.
              </span>
            </b-row>

            <b-row>
              <span class="faq">What Is A Virtual Box Address?</span>
            </b-row>

            <b-row>
              <span class="faq-answer">
                A Virtual Postal Address is an Electronic Postal Address that
                allows you to access your mails 24/7 from the convenience of
                your smartphone and any other electronic device. Once new mails
                or item arrives at your preferred Post Office, you will receive
                instant notifications and or monitor your mail transactions
                using your phone or your account once items/mails come to your
                box. You can then choose to ask Post Office to deliver your item
                or you can pick it at any time of your convenience. Get yourself
                a Virtual Postal Address and use it to shop online anywhere in
                the world and have your items delivered it to you wherever you
                are.
              </span>
            </b-row>

            <b-row>
              <span class="faq"
                >Can I Register From My Nearest Post Office?</span
              >
            </b-row>

            <b-row>
              <span class="faq-answer">
                Yes, you can walk into any Post Office in the country with a
                copy of a Valid National ID, Driving Permit or Passport and get
                a postal address.
              </span>
            </b-row>
          </b-col>

          <b-col class="mx-auto" col lg="6" md="11" sm="11">
            <b-row>
              <span class="faq">How Do I Acquire A Postal Address?</span>
            </b-row>

            <b-row>
              <span class="faq-answer">
                You can Register for a Postal Address online using
                www.eposta.ugapost.co.ug, downloading our mobile App- ePosta UG
                from Play Store or by Visiting a nearby Post Office. While
                online, simply navigate to [eposta.ugapost.co.ug] and select
                PHYSICAL BOX or VIRTUAL BOX. Select either Register Organization
                or Register Individual. While registering, enter a phone number
                that will receive Mail Notifications, select your preferred Post
                Office and after registering, you will receive a prompt on your
                phone requesting for your MM PIN to complete payment for your
                address.
              </span>
            </b-row>

            <b-row>
              <span class="faq">How Much Does An Postal Address Cost?</span>
            </b-row>

            <b-row>
              <span class="faq-answer">
                Physical Box addresses are available for both Individuals and
                Organizations and they cost UGX 76,500 in Kampala and UGX 51,000
                Up-country. A Virtual Postal address costs UGX 76,500 for
                Companies or Organizations and UGX 18,900 for Individuals.
              </span>
            </b-row>

            <b-row>
              <span class="faq"
                >What Other Services Are Offered By ePosta?</span
              >
            </b-row>

            <b-row>
              <span class="faq-answer">
                With ePosta, you can now buy stamps online, shop online, Request
                for Delivery, Request for Item Pickup, Access Government
                services and monitor all your mail transactions in real time.
              </span>
            </b-row>

            <b-row>
              <span class="faq"
                >How Do I Get Notified Using A Postal Address?</span
              >
            </b-row>

            <b-row>
              <span class="faq-answer">
                Once mail is sent to you, you will receive an SMS/Email
                Notification informing you about your mail item. To ensure that
                you do not miss out on any notifications, enable Promotional
                messages on your phone. Simply dial *196# and Enable/Allow all
                Messages.
              </span>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "FAQs",
};
</script>

<style scoped>
.faqs {
  width: 100%;
  height: 100%;
  /* background-color: #c40000;*/
  background-size: cover;
}

.box {
  border-radius: 6px;
  margin-right: 50px;
  margin-left: 50px;
  margin-top: 40px;
  box-shadow: 8px 10px 28px #9f0012;
}

.left {
  width: 50%;
  height: inherit;
  background-color: #f1f1f1;
  background-size: cover;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.right {
  width: 50%;
  height: inherit;
  background-color: #f1f1f1;
  background-size: cover;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.title-bar {
  background: #db0000;
  padding: 15px;
}

.links {
  text-decoration: none;
  color: #fff;
  list-style: none;
}

.links li {
  padding: 5px;
  display: inline;
}

.links .active {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

.links li:hover {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

li a {
  color: white;
  text-decoration: none;
}

.logo {
  width: 100px;
  height: 30px;
}

.faqs-header {
  color: #777777;
  margin-top: 15px;
  margin-left: 20px;
  font-weight: bold;
}

.faq {
  font-weight: bold;
  font-size: 18px;
  color: #3a3a3a;
  margin-top: 15px;
  margin-left: 20px;
}

.faq-answer {
  color: #777777;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 5px;
  font-size: 16px;
  text-align: justify;
  text-justify: inter-word;
}
</style>
